export const COMPRESS_IMAGE = 'COMPRESS_IMAGE'